import type { Dtos, SuretyQuoteId } from "@inrev/common";
import { keepPreviousData, useQuery } from "@tanstack/react-query";
import { useRequest } from "../../../utils/request";
import { type PelPmlForQuoteOverrides, pelPmlForQuoteQueryKey } from "../pel-pml.keys";

export const useBondRequestPelPml = (
	quoteId: SuretyQuoteId,
	overrides: PelPmlForQuoteOverrides,
) => {
	const { post } = useRequest();

	return useQuery({
		queryKey: pelPmlForQuoteQueryKey(quoteId, overrides),
		placeholderData: keepPreviousData,
		staleTime: 30_000,
		queryFn: async () =>
			await post<Dtos.Admin.PelPml.ForQuote.Response>(
				`/v2/admin/surety/pel-pml/quotes/${quoteId}`,
				overrides,
			),
	});
};
